import React from "react";

const Process = () => {
  const steps = [
    {
      number: "01",
      title: "بررسی نیاز و Scope",
      description: "هدف محصول، کاربران، محدودیت‌ها و خروجی مورد انتظار را روشن می‌کنیم.",
    },
    {
      number: "02",
      title: "پیشنهاد راه‌حل",
      description: "معماری، مسیر اجرا، اولویت‌ها و زمان‌بندی قابل‌فهم برای پروژه مشخص می‌شود.",
    },
    {
      number: "03",
      title: "توسعه و گزارش پیشرفت",
      description: "کار مرحله‌به‌مرحله انجام می‌شود و وضعیت، تصمیم‌ها و ریسک‌ها شفاف می‌مانند.",
    },
    {
      number: "04",
      title: "تحویل و پشتیبانی",
      description: "نسخه‌ی نهایی، مستندات و راهنمای استفاده تحویل داده می‌شود و مسیر ادامه روشن است.",
    },
  ];

  return (
    <section id="process" className="section bg-light">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">فرآیند همکاری</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-3 wow fadeInUp">همکاری از ابهام شروع نمی‌شود</h2>
        <p className="text-muted text-center text-5 mb-5 wow fadeInUp">
          هر پروژه با یک مسیر مشخص جلو می‌رود تا تصمیم‌ها، زمان و خروجی برای همه روشن باشد.
        </p>

        <div className="row gy-4">
          {steps.map((step) => (
            <div className="col-sm-6 col-lg-3 wow fadeInUp" key={step.number}>
              <div className="border rounded p-4 h-100 bg-white">
                <span className="text-primary text-6 fw-600">{step.number}</span>
                <h3 className="text-5 fw-600 mt-3 mb-3">{step.title}</h3>
                <p className="text-muted mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
